import ace from 'ace-builds/src-noconflict/ace';

$(function() {
	const ace_editor_area = document.getElementById('ace-editor');
 	if (ace_editor_area){
 		const editor = ace.edit("ace-editor");							// APPLYING EDITOR
		const hiddenInput = document.getElementById('ace-content');		// ENSURING DATA NEED TO BE TRANSFERRED

		// TRANSFERRING DATA FROM 
		if (hiddenInput) {
			editor.on('blur', function () {
				hiddenInput.value = editor.getValue();
			});
		}

		// OPTIONAL: BACKUP FOR CHECK
		const form = hiddenInput.closest('form');
		if (form) {
			form.addEventListener('submit', function () {
				if(hiddenInput.value != editor.getValue())
					{
						hiddenInput.value = editor.getValue();
					}
			});
		}

	}
});